import { render, staticRenderFns } from "./DevXReport.vue?vue&type=template&id=7bfefdd1&scoped=true&"
import script from "./DevXReport.vue?vue&type=script&lang=js&"
export * from "./DevXReport.vue?vue&type=script&lang=js&"
import style0 from "./DevXReport.vue?vue&type=style&index=0&id=7bfefdd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfefdd1",
  null
  
)

export default component.exports